import { render, staticRenderFns } from "./ChildTabs.vue?vue&type=template&id=dc76ccfe&scoped=true&"
import script from "./ChildTabs.vue?vue&type=script&lang=js&"
export * from "./ChildTabs.vue?vue&type=script&lang=js&"
import style0 from "./ChildTabs.vue?vue&type=style&index=0&id=dc76ccfe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc76ccfe",
  null
  
)

export default component.exports